module.exports = __webpack_public_path__ + "media/components/country-flag/static/ck-ae3ea163a41e7acc6ec68d293ee62911.svg";